'use client';
import { Disclosure } from '@headlessui/react';
import Button from '@ui/Button';
import Chip from '@ui/Chip';
import FadeTransition from '@ui/Transitions/FadeTransition';
import Typography from '@ui/Typography';
import React from 'react';
import { HiOutlinePlusCircle } from 'react-icons/hi';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import useUserSkillsStore from './store';
import Image from 'next/image';
import { revalidatePage } from '@/actions/server.actions';
import useEditProfileStore from '@/components/store/editProfileModalSlice';

function SkillsList(props) {
  const { title, skills, expanded = false, user } = props;
  const setShowEditor = useUserSkillsStore((state) => state.setShowEditor);
  const setIsOpen = useEditProfileStore((state) => state.setOpen);

  const handleEdit = () => {
    setShowEditor(true, skills);
    setIsOpen(true, user, 'Skills');
  };

  return (
    <Disclosure defaultOpen={expanded}>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full items-center justify-between">
            <div className="flex items-center justify-start gap-4">
              <Image
                width={40}
                height={40}
                src="/assets/icons/skills.svg"
                alt="skills"
                className="h-10 w-10"
              />
              <Typography variant="h3" className="text-left">
                {title}
              </Typography>
            </div>
            <MdOutlineKeyboardArrowDown
              className={`${
                open ? 'rotate-180 transform' : ''
              } h-5 w-5 text-text-secondary`}
            />
          </Disclosure.Button>
          <FadeTransition>
            <Disclosure.Panel className="mt-6 flex flex-wrap items-center justify-start gap-4">
              {skills.length === 0 && (
                <div className="flex flex-1 items-center justify-start">
                  <Typography variant="h4" color="textDisabled">
                    No skills added yet
                  </Typography>
                </div>
              )}

              {skills.map((skill) => (
                <Chip key={skill.id} color="secondary" text="small">
                  {skill.skill_title}
                </Chip>
              ))}

              <Button variant="icon" className="!p-0" onClick={handleEdit}>
                <HiOutlinePlusCircle className="h-9 w-9 text-chips-primary" />
              </Button>
            </Disclosure.Panel>
          </FadeTransition>
        </>
      )}
    </Disclosure>
  );
}

export default SkillsList;
